import React from "react";
import "../css/components/MainFilter.scss";

const MainFilter = () => {
  return (
    <div className="main-filter">
      <div>카테고리</div>
      <div>필터</div>
    </div>
  );
};

export default MainFilter;
